webpackJsonp([213534597649335],{

/***/ "./src/components/fullscreen/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _stylesModule = __webpack_require__("./src/components/fullscreen/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fullscreen = function Fullscreen(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      firstItem = _ref.firstItem;
	
	  var containerClassName = (0, _classnames2.default)(firstItem ? _stylesModule2.default.first : _stylesModule2.default.fullscreen, className);
	
	  return _react2.default.createElement(
	    'div',
	    { className: containerClassName },
	    children
	  );
	};
	
	exports.default = Fullscreen;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/fullscreen/styles.module.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"fullscreen":"src-components-fullscreen----styles-module---fullscreen---1zd9L","first":"src-components-fullscreen----styles-module---first---1NMJC src-components-fullscreen----styles-module---fullscreen---1zd9L"};

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/puangmalai/Desktop/hiimp/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/puangmalai/Desktop/hiimp/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fullscreen = __webpack_require__("./src/components/fullscreen/index.jsx");
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _meta = __webpack_require__("./src/components/meta/index.jsx");
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _wrapper = __webpack_require__("./src/components/wrapper/index.jsx");
	
	var _wrapper2 = _interopRequireDefault(_wrapper);
	
	var _stylesModule = __webpack_require__("./src/pages/styles.module.css");
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_meta2.default, { location: location }),
	    _react2.default.createElement(
	      _fullscreen2.default,
	      { className: _stylesModule2.default.intro, firstItem: true },
	      _react2.default.createElement(
	        _wrapper2.default,
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Hi. I\u2019m ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _stylesModule2.default.bracklink, to: '/about' },
	            '{',
	            'Mike',
	            '}'
	          ),
	          ' P.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'I\u2019m a software developer & tech analyst.',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          'Check out some of my ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _stylesModule2.default.link, to: '/projects' },
	            'projects'
	          ),
	          '.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/pages/styles.module.css":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-pages----styles-module---intro---2Dr5P","fourohfour":"src-pages----styles-module---fourohfour---25IV6","link":"src-pages----styles-module---link---3nvcj","bracklink":"src-pages----styles-module---bracklink---2njbs"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-3304d9c637befdd21b60.js